import "./index.css";

interface TextProps {
  text: string;
  type?: TemplateType;
  style?: React.CSSProperties;
}

const Text = (props: TextProps) => {
  const { text, style = {}, type } = props;

  const formatText = (text: string) => ({
    __html: text.replace(/\n/g, "<br>"),
  });

  return (
    <div
      className={`base-text base-text-${type}`}
      style={style}
      dangerouslySetInnerHTML={formatText(text)}
    />
  );
};

export default Text;
